import { createParentalReauthClient } from './supabase/client.js';

// The returned lease lives only in component memory. The dedicated client has
// no URL token detection, token refresh, persistent storage, or shared session.
export async function reauthenticateParentalAccount(email, password) {
  if (!String(email || '').trim() || !password) throw new Error('Enter your WatchVIM account email and password.');
  const client = createParentalReauthClient();
  let disposed = false;
  const dispose = () => {
    if (disposed) return;
    disposed = true;
    // Revoke only this temporary refresh session, not other signed-in devices.
    void client.auth.signOut({ scope: 'local' }).catch(() => {});
  };
  try {
    const { data, error } = await client.auth.signInWithPassword({
      email: String(email).trim().toLowerCase(), password,
    });
    if (error || !data?.session?.access_token || !data?.user?.id) {
      throw new Error('Account verification failed. Check your email and password and try again.');
    }
    return { accessToken: data.session.access_token, email: data.user.email, dispose };
  } catch (error) {
    dispose();
    throw error;
  }
}
